import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ViUIService } from '@vi-iot/ui';

import {
  hideInstallationsAnnouncementBannerKey,
  temporarilyHideInstallationsAnnouncementBanner,
} from '@store';

import { environment } from '../../../../environments/environment';

// Domain change - deletion a whole component recommended

@Component({
  selector: 'app-announcement-banner',
  templateUrl: './announcement-banner.component.html',
  styleUrls: ['./announcement-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnouncementBannerComponent implements OnInit, OnDestroy {
  link: string;

  constructor(
    private viUIService: ViUIService,
    private dialogRef: MatDialogRef<AnnouncementBannerComponent>
  ) {}

  ngOnInit(): void {
    this.viUIService.hideBodyScrollbar();
    this.link = this.getLink();
  }

  private getLink(): string {
    const languageLocale = navigator.language;
    switch (languageLocale) {
      case 'de-DE':
        return 'https://partnerportal.viessmann-climatesolutions.com/de/de/informieren/neuigkeiten/vitoguide---der-digitale-werkzeugkasten-fuer-unsere-fachpartner-.html';

      case 'de-AT':
        return 'https://partnerportal.viessmann-climatesolutions.com/at/de/informieren/neuigkeiten/vitoguide---der-digitale-werkzeugkasten-fuer-unsere-fachpartner-.html';

      case 'de-CH':
        return 'https://partnerportal.viessmann-climatesolutions.com/ch/de/informieren/neuigkeiten/vitoguide---der-digitale-werkzeugkasten-fuer-unsere-fachpartner-.html';

      case 'fr-FR':
        return 'https://partnerportal.viessmann-climatesolutions.com/fr/fr/informer/actualite/changements-vitoguide.html';

      case 'it-IT':
        return 'https://partnerportal.viessmann-climatesolutions.com/it/it/home-page/cambio-nome-vitoguide.html';

      case 'pl-PL':
        return 'https://partnerportal.viessmann-climatesolutions.com/pl/pl/aktualnosci/wiadomosci/vitoguide-zmienia-nazwe-na-viguide.html';

      default:
        return 'https://partnerportal.viessmann-climatesolutions.com/de/de/informieren/neuigkeiten/vitoguide---der-digitale-werkzeugkasten-fuer-unsere-fachpartner-.html';
    }
  }

  closeAndDontShowAgain(): void {
    localStorage.setItem(hideInstallationsAnnouncementBannerKey, 'true');
    this.dialogRef.close();
  }

  closeForTokenLifetime(): void {
    const localStorageKey: string = environment.csrfTokenConfig.localStorageKey;
    const token: string = localStorage.getItem(localStorageKey);
    localStorage.setItem(temporarilyHideInstallationsAnnouncementBanner, token);
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.viUIService.unhideBodyScrollbar();
  }
}
